const toSafeNumber = (value, fallback = 0) => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

export const computeLineItemAmountCents = (lineItem = {}) =>
  toSafeNumber(lineItem.quantity) * toSafeNumber(lineItem.unit_price_cents)

const computeSubtotalCents = (lineItems = []) =>
  lineItems.reduce((sum, item) => sum + computeLineItemAmountCents(item), 0)

const computeDiscountCents = (discount = {}, subtotalCents = 0) => {
  if (discount.type === 'PERCENT') {
    return Math.round(subtotalCents * (toSafeNumber(discount.percent) / 100))
  }

  return toSafeNumber(discount.amount_cents)
}

const computeDiscountTotalCents = (
  discountLineItems = [],
  subtotalCents = 0
) =>
  discountLineItems.reduce(
    (sum, discount) => sum + computeDiscountCents(discount, subtotalCents),
    0
  )

export const discountRowLabel = (discountLineItems = [], fallbackLabel) => {
  if (!Array.isArray(discountLineItems) || discountLineItems.length === 0) {
    return fallbackLabel
  }

  const trimmedNames = discountLineItems
    .map((d) => (typeof d?.name === 'string' ? d.name.trim() : ''))
    .filter(Boolean)

  if (trimmedNames.length === 0) {
    return fallbackLabel
  }

  const uniqueNames = [...new Set(trimmedNames)]

  if (trimmedNames.length === discountLineItems.length) {
    return uniqueNames.join(', ')
  }

  return `${uniqueNames.join(', ')}, ${fallbackLabel}`
}

const parseInvoiceTaxRatePercent = (taxRate) => {
  if (taxRate === null || taxRate === undefined) {
    return null
  }

  const trimmed = `${taxRate}`.trim()
  if (trimmed === '') {
    return null
  }

  const parsed = Number(trimmed)
  return Number.isFinite(parsed) ? parsed : null
}

export const computeInvoiceTotals = (invoice = {}) => {
  const lineItems = invoice.line_items || []
  const discounts = invoice.discount_line_items || []
  const subtotalCents = computeSubtotalCents(lineItems)
  const discountTotalCents = computeDiscountTotalCents(discounts, subtotalCents)
  const taxableCents = Math.max(0, subtotalCents - discountTotalCents)
  const parsedTaxRate = parseInvoiceTaxRatePercent(invoice?.invoice_settings?.tax_rate) ?? 0
  const taxTotalCents = Math.round(taxableCents * (parsedTaxRate / 100))
  const totalCents = taxableCents + taxTotalCents

  return {
    subtotalCents,
    discountTotalCents,
    taxableCents,
    taxTotalCents,
    totalCents,
    parsedTaxRate,
  }
}
